import { render, staticRenderFns } from "./profilePage.vue?vue&type=template&id=8920f86c&scoped=true&"
import script from "./profilePage.vue?vue&type=script&lang=js&"
export * from "./profilePage.vue?vue&type=script&lang=js&"
import style0 from "./profilePage.vue?vue&type=style&index=0&id=8920f86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8920f86c",
  null
  
)

export default component.exports